<template>
    <v-select v-model="state"
              :items="items"
              :rules="isDisabled ? [] : nameRules"
              label="Пол"
              :disabled="isDisabled"
              :menu-props="{ bottom: true, offsetY: true }"
    ></v-select>
</template>

<script>
    export default {
        props: {
            value: {},
            isDisabled: {
                default: false
            }
        },
        data: () => ({
            items: ['Мужской', 'Женский'],
            state: null,
            nameRules: [
                v => !!v || 'Обязательное поле'
            ]
        }),
        mounted() {
            this.state = this.value;
        },
        watch: {
            value(val) {
                this.state = val;
            },
            state() {
                this.$emit("input", this.state);
                this.$emit("change", this.state);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/fields/Gender.vue